var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDOhorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "272px",
    height: "41px",
    viewBox: "0 0 285 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DOhorizontal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(-283.000000, -24.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DOhorizontal",
    transform: "translate(285.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B.-Digital,--Tech-&-Docs/d.-Symbols/BD900-popup-|-SYMBOLS,-window,-pop-up",
    transform: "translate(20.404683, 21.985071) rotate(-135.000000) translate(-20.404683, -21.985071) translate(8.656746, 10.228810)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.228852,0 L9.25949336,1.42185001 L3.45465568,1.40272621 C2.3098835,1.40272621 1.38186228,2.33074741 1.38186228,3.47551961 L1.38186228,20.0578669 C1.38186228,21.2026391 2.3098835,22.1306603 3.45465568,22.1306603 L20.0370029,22.1306603 C21.1817751,22.1306603 22.1097963,21.2026391 22.1097963,20.0578669 L22.1250889,15.5034186 L23.4958734,15.5077156 L23.4916586,20.0578669 C23.4916586,21.9658205 21.9449566,23.5125225 20.0370029,23.5125225 L3.45465568,23.5125225 C1.54670204,23.5125225 2.77555756e-16,21.9658205 2.77555756e-16,20.0578669 L2.77555756e-16,3.47551961 C2.77555756e-16,1.56756601 1.54670204,0.02086394 3.45465568,0.02086394 L9.228852,0 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-System-/-ic_arrow_right",
    transform: "translate(0.000000, 6.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.205638363,1.2663269 C-0.0791999466,0.965679892 -0.0665781019,0.490866664 0.233830042,0.205801872 C0.534238186,-0.0792629207 1.00867418,-0.06663104 1.29351248,0.234015967 L14.7943633,14.4841721 C15.0685501,14.7735765 15.0685449,15.2270975 14.7943515,15.5164956 L1.29350064,29.7659965 C1.00865544,30.066637 0.534219159,30.079258 0.233817554,29.7941863 C-0.06658405,29.5091146 -0.0791950027,29.0343011 0.205650203,28.7336606 L13.2174631,15.0003157 L0.205638363,1.2663269 Z",
    id: "ic_arrow_right"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-System-/-ic_arrow_right",
    transform: "translate(0.000000, 6.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.205638363,1.2663269 C-0.0791999466,0.965679892 -0.0665781019,0.490866664 0.233830042,0.205801872 C0.534238186,-0.0792629207 1.00867418,-0.06663104 1.29351248,0.234015967 L14.7943633,14.4841721 C15.0685501,14.7735765 15.0685449,15.2270975 14.7943515,15.5164956 L1.29350064,29.7659965 C1.00865544,30.066637 0.534219159,30.079258 0.233817554,29.7941863 C-0.06658405,29.5091146 -0.0791950027,29.0343011 0.205650203,28.7336606 L13.2174631,15.0003157 L0.205638363,1.2663269 Z",
    id: "ic_arrow_right"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Digital-Optimization",
    transform: "translate(45.000000, 0.000000)",
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 1.42108547e-14,
    y: 32
  }, "Digital Optimization"))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDOhorizontal);
export default __webpack_public_path__ + "static/media/DOhorizontal.babbbb4700f9fb1894960b226ba73b0b.svg";
export { ForwardRef as ReactComponent };